__turbopack_context__.v({
  "NewsDesc": "newsBlock-module-scss-module__hxUzzq__NewsDesc",
  "TitleDesc": "newsBlock-module-scss-module__hxUzzq__TitleDesc",
  "button": "newsBlock-module-scss-module__hxUzzq__button",
  "h3": "newsBlock-module-scss-module__hxUzzq__h3",
  "loadMoreBtn": "newsBlock-module-scss-module__hxUzzq__loadMoreBtn",
  "xBg": "newsBlock-module-scss-module__hxUzzq__xBg",
});
